export default "__VITE_ASSET__lXt9iQAX__"